require('./dist/angular-jwt.js');
module.exports = 'angular-jwt';




/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-jwt/index.js
 ** module id = 239
 ** module chunks = 1
 **/